import { useEffect, useState, type ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import type { ToasterProps } from 'sonner';
import { Button } from '@/components/ui/button';

/** 미리보기 팝업을 따로 준비하고, 로딩 실패에도 현재 화면과 새로고침을 유지한다. */
export default function DemoToaster() {
  const { t } = useTranslation();
  const [Renderer, setRenderer] = useState<ComponentType<ToasterProps> | null>(
    null,
  );
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let current = true;
    void import('sonner')
      .then(({ Toaster }) => {
        if (current) setRenderer(() => Toaster);
      })
      .catch(() => {
        if (current) setFailed(true);
      });
    return () => {
      current = false;
    };
  }, []);
  if (failed)
    return (
      <div className="fixed inset-x-4 bottom-24 z-50 mx-auto max-w-sm rounded-card border border-gp-pink-100 bg-gp-cream p-4 text-body text-gp-ink-900 shadow-glow">
        <p role="alert">{t('status.error')}</p>
        <Button
          type="button"
          className="mt-3"
          onClick={() => window.location.reload()}
        >
          {t('entry.retry')}
        </Button>
      </div>
    );
  return Renderer ? <Renderer position="top-center" richColors /> : null;
}
